import { httpGet, httpPost, httpPut, httpDelete } from "@/lib/api/sdk-instance.js";

export const bcmInitialResponseApi = {
    getAll: (params) => httpGet("/bcm-initial-response-library", params),
    getById: (id) => httpGet(`/bcm-initial-response-library/${id}`),
    create: (data) => httpPost("/bcm-initial-response-library", data),
    update: (id, data) => httpPut(`/bcm-initial-response-library/${id}`, data),
    delete: (id) => httpDelete(`/bcm-initial-response-library/${id}`),
    batchDelete: (ids) => httpPost("/bcm-initial-response-library/batch-delete", { ids }),
    getRelated: (bcpId, params) => httpGet(`/bcp/${bcpId}/initial-response`, params),
    link: (bcpId, stepIds) => httpPost(`/bcp/${bcpId}/initial-response`, { stepIds }),
    unlink: (bcpId, stepId) => httpDelete(`/bcp/${bcpId}/initial-response/${stepId}`),
};
